import { makeStyles } from '@material-ui/core';

import { neutral } from 'shared/styles/colors';
import {
  MAIN_LAYOUT_FOOTER_HEIGHT,
  MAIN_LAYOUT_HEADER_HEIGHT,
} from 'shared/styles/constants';

const autoHideScrollbar = {
  scrollbarWidth: 'thin' as const,
  scrollbarColor: 'transparent transparent',
  '&:hover, &:focus-within': {
    scrollbarColor: `${neutral[40]} transparent`,
  },
  '&::-webkit-scrollbar': {
    width: '0.5rem',
    height: '0.5rem',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'transparent',
    borderRadius: '0.25rem',
  },
  '&:hover::-webkit-scrollbar-thumb, &:focus-within::-webkit-scrollbar-thumb': {
    backgroundColor: neutral[40],
  },
};

export default makeStyles(theme => ({
  root: {
    marginTop: MAIN_LAYOUT_HEADER_HEIGHT,
    marginBottom: MAIN_LAYOUT_FOOTER_HEIGHT,
  },
  backdrop: {
    marginTop: MAIN_LAYOUT_HEADER_HEIGHT,
    marginBottom: MAIN_LAYOUT_FOOTER_HEIGHT,
  },
  paper: {
    position: 'relative',
    padding: '0.75rem 1rem 1rem 1rem',
    boxShadow: 'none',
    '@media print': {
      display: 'none',
    },
    [theme.breakpoints.up('md')]: {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      height: '100vh',
      width: '100%',
      maxWidth: '54.875rem',
      padding: '0.75rem 1rem 1.5rem 1.5rem',
      overflowY: 'hidden',
    },
  },
  title: {
    fontFamily: 'PP Object Sans',
    fontWeight: 700,
    lineHeight: '2rem',
    color: neutral[100],
    padding: 0,
  },
  headerRoot: {
    border: 'none',
  },
  headerActions: {
    justifySelf: 'end',
    display: 'flex',
    alignItems: 'center',
  },
  stateWrapper: {
    height: '100%',
    overflow: 'auto',
    padding: '1rem',
    ...autoHideScrollbar,
  },
  layout: {
    height: '100%',
    overflow: 'auto',
    ...autoHideScrollbar,
    [theme.breakpoints.up('md')]: {
      display: 'grid',
      columnGap: '1.5rem',
      gridTemplateAreas: `
        "products main"
        "total main"`,
      gridTemplateColumns: '1fr 21.25rem',
      gridTemplateRows: '1fr auto',
      overflow: 'hidden',
    },
  },
  productsArea: {
    gridArea: 'products',
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    minHeight: 0,
    [theme.breakpoints.up('md')]: {
      overflow: 'auto',
      ...autoHideScrollbar,
    },
  },
  totalArea: {
    gridArea: 'total',
    padding: '1rem 0.75rem 0',
  },
  mainArea: {
    gridArea: 'main',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      overflow: 'auto',
      ...autoHideScrollbar,
    },
  },
  cancelButton: {
    appearance: 'none',
    font: 'inherit',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: neutral.white,
    border: `1px solid ${neutral[90]}`,
    borderRadius: '0.5rem',
    height: '3rem',
    width: '100%',
    marginTop: 'auto',
    cursor: 'pointer',
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.3125rem',
    color: neutral[80],
  },
  printButtonDisabled: {
    opacity: 0.4,
    pointerEvents: 'none',
  },
}));
